import { render, staticRenderFns } from "./ContractModule.vue?vue&type=template&id=7cad99b7&"
import script from "./ContractModule.vue?vue&type=script&lang=js&"
export * from "./ContractModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cad99b7')) {
      api.createRecord('7cad99b7', component.options)
    } else {
      api.reload('7cad99b7', component.options)
    }
    module.hot.accept("./ContractModule.vue?vue&type=template&id=7cad99b7&", function () {
      api.rerender('7cad99b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/contracts/ContractModule.vue"
export default component.exports